angular.module('iqxCore')
.controller('HelpCtrl', function ($scope, ApplicationSvc, $templateRequest) {
  $scope.template = ""

  $scope.getFAQ = function() {
      $templateRequest(`/views/pagetext/help.${ApplicationSvc.currentUser.UserClass.toLowerCase()}.html`)
      .then(function(template) {
        $scope.template = template
    })
  }

  $scope.getFAQ()
})
